import React, { Component } from 'react';
import TableEvents from './../../Global/Modules/TableEvents'

class Toelatingseisen extends Component {

  render() {
    return (
      <div className="route">
        <h1 className="pageTitle">
          Evenementenkalender
          </h1>
        <TableEvents />
      </div>
    );
  }
}

export default Toelatingseisen;



// WEBPACK FOOTER //
// ./src/components/Public/Pages/Evenementen-kalender.js